import { getTwitterOnClick } from 'component-library/buttons/Sharing/utils/get-twitter-on-click'
import { getFacebookOnClick } from 'component-library/buttons/Sharing/utils/get-facebook-on-click'
import { getEmailOnClick } from 'component-library/buttons/Sharing/utils/get-email-on-click'
import { getClipboardOnClick } from 'component-library/buttons/Sharing/utils/get-clipboard-on-click'

import { addUrlParams } from 'common/helpers/utils'
import { ShareOption } from 'common/events/share-events'

// @TODO: WhatsApp and Reddit functionality needs to be added
export const getButtonOnClick = (
    shareOption: ShareOption,
    url: string,
    text: string,
    fbAppId: string
) => {
    const shareUrl = addUrlParams(url, [
        ['utm_campaign', 'share-icons'],
        ['utm_source', shareOption],
        [
            'utm_medium',
            ['facebook', 'twitter'].indexOf(shareOption) !== -1 ? 'social' : shareOption,
        ],
        ['tid', `${Date.now()}`],
    ])

    switch (shareOption) {
        case 'facebook':
            return getFacebookOnClick(shareUrl, text, fbAppId)
        case 'twitter':
            return getTwitterOnClick(shareUrl, text)
        // case 'whatsapp': return
        case 'email':
            return getEmailOnClick(shareUrl, text)
        // case 'reddit': return
        case 'clipboard':
            return getClipboardOnClick(shareUrl)
        default:
            return () => undefined
    }
}
